import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentEcheck: {
        id: "twia.quoteandbind.residential.views.paymentEcheck",
        defaultMessage: "Payment via eCheck is NOT available for checks from Mortgage Companies."
    },
    guidelines: {
        id: "twia.quoteandbind.residential.views.guidelines",
        defaultMessage: "Required eCheck Payment Authorization Forms and Guidelines are found "
    },
    readAndApprove: {
        id: "twia.quoteandbind.residential.views.readAndApprove",
        defaultMessage: "Please Read and Approve the Following Information"
    },
    byClicking: {
        id: "twia.quoteandbind.residential.views.byClicking",
        defaultMessage: "By clicking \"I have read and acknowledge the Terms and Conditions for ACH payment processing\", I affirm that I have received authorization from the account holder stating that TWIA may electronically debit the account holder's bank account for the amount(s) on the scheduled payment date shown on the payment screen. This authorization is valid for this transaction only."
    },
    returnPayment: {
        id: "twia.quoteandbind.residential.views.returnPayment",
        defaultMessage: "In the event that a payment is returned for insufficient funds, the policy will be cancelled."
    },
    savingsMsg:{
        id: "twia.quoteandbind.residential.views.savingsMsg",
        defaultMessage: "Please insure the savings account allows eCheck withdrawals."
    },
    businessAccount: {
        id: "twia.quoteandbind.residential.views.businessAccount",
        defaultMessage: "This application does not support Business Savings"
    }
});
